import React from 'react'

function FraniBackgroundIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H72V72H0z"
            data-name="Rectangle 7960"
            transform="translate(810.43 313.43)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 224" transform="translate(-810.43 -313.43)">
        <g data-name="Group 53811" transform="translate(798.074 301.229)">
          <g data-name="Group 53810" transform="translate(24.221 24.684)">
            <g stroke="#263238" strokeMiterlimit="10" strokeWidth="1" transform="translate(0 1.494)">
              <path
                fill="#fff"
                d="M45.916 0H2.355A2.34 2.34 0 00.688.7 2.4 2.4 0 000 2.39v40.765a2.37 2.37 0 002.355 2.385h43.561a2.37 2.37 0 002.355-2.385V2.39a2.4 2.4 0 00-.688-1.689A2.34 2.34 0 0045.916 0z"
                data-name="Path 66640"
              ></path>
              <path
                fill="#d3dade"
                d="M45.916 0H2.355A2.3 2.3 0 00.688.729 2.555 2.555 0 000 2.49v10.421h48.27V2.49a2.554 2.554 0 00-.688-1.759A2.3 2.3 0 0045.916 0z"
                data-name="Path 66641"
              ></path>
            </g>
            <g fill="#263238" data-name="Group 53804" transform="translate(6.362)">
              <rect
                width="0.721"
                height="2.85"
                data-name="Rectangle 7954"
                rx="0.361"
                transform="translate(.721 .18)"
              ></rect>
              <path
                d="M.041-.5a.542.542 0 01.541.541V2.17a.542.542 0 01-.541.541A.542.542 0 01-.5 2.17V.041A.542.542 0 01.041-.5zm0 2.85a.181.181 0 00.18-.18V.041a.181.181 0 00-.18-.18.181.181 0 00-.18.18V2.17a.181.181 0 00.18.18z"
                data-name="Rectangle 6708 - Outline"
                transform="translate(1.041 .5)"
              ></path>
              <circle cx="1.082" cy="1.082" r="1.082" data-name="Ellipse 1138" transform="translate(0 2.431)"></circle>
            </g>
            <g fill="#263238" data-name="Group 53805" transform="translate(13.043)">
              <rect
                width="0.721"
                height="2.85"
                data-name="Rectangle 7955"
                rx="0.361"
                transform="translate(.721 .18)"
              ></rect>
              <path
                d="M.041-.5a.542.542 0 01.541.541V2.17a.542.542 0 01-.541.541A.542.542 0 01-.5 2.17V.041A.542.542 0 01.041-.5zm0 2.85a.181.181 0 00.18-.18V.041a.181.181 0 00-.18-.18.181.181 0 00-.18.18V2.17a.181.181 0 00.18.18z"
                data-name="Rectangle 6708 - Outline"
                transform="translate(1.041 .5)"
              ></path>
              <circle cx="1.082" cy="1.082" r="1.082" data-name="Ellipse 1139" transform="translate(0 2.431)"></circle>
            </g>
            <g fill="#263238" data-name="Group 53806" transform="translate(19.63)">
              <rect
                width="0.721"
                height="2.85"
                data-name="Rectangle 7956"
                rx="0.361"
                transform="translate(.721 .18)"
              ></rect>
              <path
                d="M.041-.5a.542.542 0 01.541.541V2.17a.542.542 0 01-.541.541A.542.542 0 01-.5 2.17V.041A.542.542 0 01.041-.5zm0 2.85a.181.181 0 00.18-.18V.041a.181.181 0 00-.18-.18.181.181 0 00-.18.18V2.17a.181.181 0 00.18.18z"
                data-name="Rectangle 6708 - Outline"
                transform="translate(1.041 .5)"
              ></path>
              <circle cx="1.082" cy="1.082" r="1.082" data-name="Ellipse 1140" transform="translate(0 2.431)"></circle>
            </g>
            <g fill="#263238" data-name="Group 53807" transform="translate(26.582)">
              <rect
                width="0.721"
                height="2.85"
                data-name="Rectangle 7957"
                rx="0.361"
                transform="translate(.721 .18)"
              ></rect>
              <path
                d="M.041-.5a.542.542 0 01.541.541V2.17a.542.542 0 01-.541.541A.542.542 0 01-.5 2.17V.041A.542.542 0 01.041-.5zm0 2.85a.181.181 0 00.18-.18V.041a.181.181 0 00-.18-.18.181.181 0 00-.18.18V2.17a.181.181 0 00.18.18z"
                data-name="Rectangle 6708 - Outline"
                transform="translate(1.041 .5)"
              ></path>
              <circle cx="1.082" cy="1.082" r="1.082" data-name="Ellipse 1141" transform="translate(0 2.431)"></circle>
            </g>
            <g fill="#263238" data-name="Group 53808" transform="translate(33.169)">
              <rect
                width="0.721"
                height="2.85"
                data-name="Rectangle 7958"
                rx="0.361"
                transform="translate(.721 .18)"
              ></rect>
              <path
                d="M.041-.5a.542.542 0 01.541.541V2.17a.542.542 0 01-.541.541A.542.542 0 01-.5 2.17V.041A.542.542 0 01.041-.5zm0 2.85a.181.181 0 00.18-.18V.041a.181.181 0 00-.18-.18.181.181 0 00-.18.18V2.17a.181.181 0 00.18.18z"
                data-name="Rectangle 6708 - Outline"
                transform="translate(1.041 .5)"
              ></path>
              <circle cx="1.082" cy="1.082" r="1.082" data-name="Ellipse 1142" transform="translate(0 2.431)"></circle>
            </g>
            <g fill="#263238" data-name="Group 53809" transform="translate(39.848)">
              <rect
                width="0.721"
                height="2.85"
                data-name="Rectangle 7959"
                rx="0.361"
                transform="translate(.721 .18)"
              ></rect>
              <path
                d="M.041-.5a.542.542 0 01.541.541V2.17a.542.542 0 01-.541.541A.542.542 0 01-.5 2.17V.041A.542.542 0 01.041-.5zm0 2.85a.181.181 0 00.18-.18V.041a.181.181 0 00-.18-.18.181.181 0 00-.18.18V2.17a.181.181 0 00.18.18z"
                data-name="Rectangle 6708 - Outline"
                transform="translate(1.041 .5)"
              ></path>
              <circle cx="1.082" cy="1.082" r="1.082" data-name="Ellipse 1143" transform="translate(0 2.431)"></circle>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default FraniBackgroundIcon
